import React from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import moment from 'moment';

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";
import { formatNullable } from "../../../../../../common/src/util/dataUtil";
import config from "../../../../../../server/src/config";

import * as AdminActions from "../../../../actions/admin";
import {confirm} from "../../../../utils/confirmDialog";
import {NotificationManager} from "react-notifications";
import UserRoles from "../../../../../../common/src/enums/UserRoles";
import {replace} from "react-router-redux";
import {ROUTE_PIGEON_HOLE} from "../../../../constants/routeconstants";

class PigeonHoleVaccination extends React.Component {

    static propTypes = {
        pigeonhole: PropTypes.object,
    };

    constructor(props) {
        super(props);
        const now = new Date();
        const yr = now.getFullYear().toString();
        this.state = {
            editIx: null,
            selected: [],
            defaultSelected: false,
            vaccDateEnabled: 0,
            vaccDate: "",
            vaccControllerEnabled: 0,
            vaccController: "",
            activeEnabled: 0,
            active: 0,
            year: yr.substr(yr.length - 2),
            ageFilter: "all",
        };
    }

    pigeonFields = [];
    groupFields = [];
    render() {
        const pigeons = this.props.pigeonhole.Duer
            .filter(pigeon => this.state.ageFilter === "all" || (this.state.ageFilter === "young" && pigeon.Koen === "X") || (this.state.ageFilter === "old" && pigeon.Koen !== "X"))
            .sort((p1, p2) => {
                const result = p1.Ringnummer.substr(-4).localeCompare(p2.Ringnummer.substr(-4), "da-DK");
                if (result !== 0) return result;
                return p1.Ringnummer.localeCompare(p2.Ringnummer, "da-DK");
            });
        const selectedRings = pigeons.map(pigeon => pigeon.Ringnummer).filter(ring => this.state.selected.includes(ring));
        return <div className={"form-page pigeon-hole-vaccination"}>
            <div className={"left-panel"}>
                <div id={"data-table"} className={"top-panel"}>
                    <table className="data-table">
                        <thead>
                        <th></th>
                        <th>Ringnummer</th>
                        <th>Køn</th>
                        <th>Vaccinationsdato</th>
                        <th>Kontrollant</th>
                        <th>Aktiv</th>
                        <th></th>
                        </thead>
                        <tbody>
                        {pigeons.map(pigeon => <tr key={pigeon.Ringnummer} id={'row-' + pigeon.Ringnummer}>
                            <td>
                                <input type="checkbox" checked={!this.state.defaultSelected === this.state.selected.includes(pigeon.Ringnummer)} disabled={this.state.editIx !== null} onChange={(e) => {
                                    const ix = this.state.selected.indexOf(pigeon.Ringnummer);
                                    if (ix > -1) this.state.selected.splice(ix, 1);
                                    else this.state.selected.push(pigeon.Ringnummer);
                                    this.forceUpdate();
                                }}/>
                            </td>
                            <td>{pigeon.Ringnummer}</td>
                            <td>{pigeon.Koen}</td>
                            <td>{
                                this.state.editIx === pigeon.Ringnummer ? <UserFieldElement dataType={UserFieldDataType.date} placeholder="" className="field-1 medium-field" containerClassName="display-inline-block"
                                                                                            name="VaccDato1" id="VaccDato1" maxLength="10" value={this.state.VaccDato1}
                                                                                            autoCheckErrors={true} required={false} hideErrWhenFocused={false} hideErrUntilFocused={true}
                                                                                            onChange={this.onStandardFieldChange}
                                                                                            ref={instance => { this.pigeonFields[0] = instance; }}
                                /> : pigeon.VaccDato1 === null ? null : moment(pigeon.VaccDato1).format(config.formats.dateFormat)
                            }</td>
                            <td>{
                                this.state.editIx === pigeon.Ringnummer ? <UserFieldElement dataType={UserFieldDataType.string} placeholder="" className="field-1 medium-field" containerClassName="display-inline-block"
                                                                                            name="VaccKontrollant1" id="VaccKontrollant1" maxLength="25" value={this.state.VaccKontrollant1}
                                                                                            autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                                                            onChange={this.onStandardFieldChange}
                                                                                            ref={instance => { this.pigeonFields[1] = instance; }}
                                /> : pigeon.VaccKontrollant1
                            }</td>
                            <td className="center">{
                                this.state.editIx === pigeon.Ringnummer ?
                                    <input type="checkbox" name="Aktiv" id="Aktiv" checked={this.state.Aktiv !== 0} onChange={this.onCheckFieldChange}/>
                                : pigeon.Aktiv
                            }</td>
                            <td>{
                                this.state.editIx === pigeon.Ringnummer ? [
                                    <i key={0} className="fa fa-save clickable" title="Gem due" onClick={this.saveRow}/>,
                                    <i key={1} className="fa fa-undo clickable" title="Annuller" onClick={this.cancelEdit}/>
                                ] : [
                                    <i key={0} className={"fa fa-pencil " + (this.state.editIx === null ? 'clickable' : 'disabled')} title="Rediger due" onClick={() => {
                                        if (this.state.editIx === null){
                                            this.setState({
                                                VaccDato1: pigeon.VaccDato1 === null ? "" : moment(pigeon.VaccDato1).format(config.formats.dateFormat),
                                                VaccKontrollant1: pigeon.VaccKontrollant1,
                                                Aktiv: pigeon.Aktiv === null ? 0 : -1,
                                                editIx: pigeon.Ringnummer,
                                            });
                                        }
                                    }}/>
                                ]
                            }</td>
                        </tr>)}
                        </tbody>
                    </table>
                </div>
                <div className={"bottom-panel"}>
                    <UserFieldElement dataType={UserFieldDataType.options} placeholder="" className="field-1 option-buttons"
                                      name="ageFilter" id="ageFilter" value={this.state.ageFilter} options={[{key: "all", value: "Vis alle"}, {key: "old", value: "Vis kun gamle"}, {key: "young", value: "Vis kun unger"}]}
                                      autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                      onChange={this.onStandardFieldChange}
                    />
                </div>
            </div>
            <div className={"right-panel"}>
                <div className={"first-section counters"}>
                    <table>
                        <tbody>
                        <tr>
                            <td className={"label"}>Antal duer</td>
                            <td className={"value"}>{this.props.pigeonhole.Duer.length}</td>
                        </tr>
                        <tr>
                            <td className={"label"}>Antal aktive</td>
                            <td className={"value"}>{this.props.pigeonhole.Duer.filter(pigeon => pigeon.Aktiv !== null).length}</td>
                        </tr>
                        <tr>
                            <td className={"label"}>Antal unger</td>
                            <td className={"value"}>{this.props.pigeonhole.Duer.filter(pigeon => pigeon.Koen === "X").length}</td>
                        </tr>
                        <tr>
                            <td className={"label"}>Antal aktive unger</td>
                            <td className={"value"}>{this.props.pigeonhole.Duer.filter(pigeon => pigeon.Aktiv !== null && pigeon.Koen === "X").length}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div className={"last-section group-updates"}>
                    <table>
                        <tbody>
                        <tr className={"header-row"}>
                            <td colSpan={2}><label>Gruppeopdatering</label></td>
                        </tr>
                        <tr className={"form-row"}>
                            <td>
                                <input type="checkbox" name="vaccDateEnabled" id="vaccDateEnabled" checked={this.state.vaccDateEnabled !== 0} onChange={this.onCheckFieldChange}/>
                                <label htmlFor="vaccDateEnabled">Vaccinationsdato</label>
                            </td>
                            <td>
                                <UserFieldElement dataType={UserFieldDataType.date} placeholder="" className="field-1 medium-field" containerClassName="display-inline-block"
                                                  name="vaccDate" id="vaccDate" maxLength="10" value={this.state.vaccDate}
                                                  autoCheckErrors={true} required={false} hideErrWhenFocused={false} hideErrUntilFocused={true}
                                                  onChange={this.onStandardFieldChange}
                                                  onKeyPress={this.onGenderKeyPress}
                                                  disabled={this.state.vaccDateEnabled === 0}
                                                  ref={instance => { this.groupFields[0] = instance; }}
                                />
                            </td>
                        </tr>
                        <tr className={"form-row"}>
                            <td>
                                <input type="checkbox" name="vaccControllerEnabled" id="vaccControllerEnabled" checked={this.state.vaccControllerEnabled !== 0} onChange={this.onCheckFieldChange}/>
                                <label htmlFor="vaccControllerEnabled">Kontrollant</label>
                            </td>
                            <td>
                                <UserFieldElement dataType={UserFieldDataType.string} placeholder="" className="field-1 medium-field" containerClassName="display-inline-block"
                                                  name="vaccController" id="vaccController" maxLength="25" value={this.state.vaccController}
                                                  autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                  onChange={this.onStandardFieldChange}
                                                  onKeyPress={this.onGenderKeyPress}
                                                  disabled={this.state.vaccControllerEnabled === 0}
                                                  ref={instance => { this.groupFields[1] = instance; }}
                                />
                            </td>
                        </tr>
                        <tr className={"form-row"}>
                            <td>
                                <input type="checkbox" name="activeEnabled" id="activeEnabled" checked={this.state.activeEnabled !== 0} onChange={this.onCheckFieldChange}/>
                                <label htmlFor="activeEnabled">Aktiv</label>
                            </td>
                            <td>
                                <input type="checkbox" name="active" id="active" checked={this.state.active !== 0} onChange={this.onCheckFieldChange} disabled={this.state.activeEnabled === 0}/>
                            </td>
                        </tr>
                        <tr className={"action-row"}>
                            <td colSpan={2}>
                                <button className="btn-primary" title={this.state.defaultSelected ? "Fjern alle duemarkeringer" : "Marker alle duer"} onClick={() => {
                                    this.setState({
                                        defaultSelected: !this.state.defaultSelected,
                                        selected: []
                                    })
                                }}>
                                    {this.state.defaultSelected ? "Fjern markeringer" : "Marker alle"}
                                </button>
                                <button className="btn-primary" title="Opdater alle markerede duer"
                                        disabled={
                                            this.state.editIx !== null ||
                                            (!this.state.vaccDateEnabled  && !this.state.vaccControllerEnabled && !this.state.activeEnabled) ||
                                            (this.state.defaultSelected && selectedRings.length >= pigeons.length) ||
                                            (!this.state.defaultSelected && selectedRings.length <= 0)
                                        } onClick={this.updateRings}>
                                    Opdater markerede
                                </button>
                                <button className="btn-dangerous" title="Slet alle ikke vaccinerede duer"
                                        disabled={
                                            this.state.editIx !== null ||
                                            !pigeons.some(pigeon => pigeon.VaccDato1 === null)
                                        } onClick={this.deleteInactive}>
                                    Slet ikke vaccinerede
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    }

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    onCheckFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.checked ? -1 : 0});
    };

    allInputValid = (fields) => {
        let result = true;
        fields.forEach((field) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    saveRow = () => {
        if (this.allInputValid(this.pigeonFields)) {
            const entity = {
                VaccDato1: this.state.VaccDato1 === "" ? null : moment(this.state.VaccDato1, config.formats.dateFormat).format('YYYY-MM-DD'),
                VaccKontrollant1: this.state.VaccKontrollant1 === "" ? null : this.state.VaccKontrollant1,
                Aktiv: this.state.Aktiv === 0 ? null : "X"
            };
            this.props.dispatch(AdminActions.updatePigeon(this.state.editIx,  entity, () => {
                NotificationManager.success("Ringnummer " + this.state.Ringnummer + " er opdateret.", "Opdatering", 4000);
                this.setState({editIx: null});
            }));
        } else {
            this.pigeonFields.forEach((field) => {
                field.setState({visited: true});
            });
        }
    };

    updateRings = () => {
        if (this.allInputValid(this.groupFields)) {
            const rings = this.props.pigeonhole.Duer.filter(pigeon =>
                !this.state.defaultSelected === this.state.selected.includes(pigeon.Ringnummer) &&
                (this.state.ageFilter === "all" || (this.state.ageFilter === "young" && pigeon.Koen === "X") || (this.state.ageFilter === "old" && pigeon.Koen !== "X"))
            ).map(pigeon => pigeon.Ringnummer);
            confirm("Opdatering", <span>Ønsker du at opdatere {rings.length} duer?</span>, () => {
                const input = {
                    Data: {},
                    Ringnumre: rings
                };
                if (this.state.vaccDateEnabled) input.Data.VaccDato1 = this.state.vaccDate === "" ? null : moment(this.state.vaccDate, config.formats.dateFormat).format('YYYY-MM-DD');
                if (this.state.vaccControllerEnabled) input.Data.VaccKontrollant1 = this.state.vaccController === "" ? null : this.state.vaccController;
                if (this.state.activeEnabled) input.Data.Aktiv = this.state.active === 0 ? null : "X";
                this.props.dispatch(AdminActions.updatePigeons(this.props.pigeonhole.Foreningsnr, this.props.pigeonhole.Slagnr, input,   () => {
                    NotificationManager.success(rings.length + " duer er opdateret.", "Opdatering", 4000);
                }));
            });
        } else {
            this.groupFields.forEach((field) => {
                field.setState({visited: true});
            });
        }
    };

    deleteInactive = () => {
        const rings = this.props.pigeonhole.Duer
            .filter(pigeon => pigeon.VaccDato1 === null &&
                (this.state.ageFilter === "all" || (this.state.ageFilter === "young" && pigeon.Koen === "X") || (this.state.ageFilter === "old" && pigeon.Koen !== "X"))
            ).map(pigeon => pigeon.Ringnummer);
        confirm("Slet", <span>Ønsker du at slette {rings.length} ringnumre?</span>, () => {
            this.props.dispatch(AdminActions.deletePigeons(this.props.pigeonhole.Foreningsnr, this.props.pigeonhole.Slagnr, {
                Ringnumre: rings
            },   () => {
                NotificationManager.success(rings.length + " ringnummre er slettet.", "Sletning", 4000);
                this.setState({selected: this.state.selected.filter(ring => !rings.includes(ring))});
            }));
        });
    };

    cancelEdit = () => {
        this.setState({editIx: null});
    };
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, null, null, {withRef: true})(PigeonHoleVaccination);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/club/subPages/PigeonHoleVaccination.js